import React from 'react';
import QRCodeGenerator from 'qrcode-generator';

type QRCodeProps = {
  value: string;
  size?: number;
  alt: string;
  className?: string;
};

export const QRCode: React.FC<QRCodeProps> = ({
  value,
  size = 200,
  alt,
  className,
}) => {
  let QR = React.useMemo(() => {
    const qr = QRCodeGenerator(0, 'L');
    qr.addData(value);
    qr.make();

    const moduleCount = qr.getModuleCount();
    const border = 1; // 1 module border
    const totalModules = moduleCount + border * 2; // Add border on all sides
    const moduleSize = Math.floor(size / totalModules);
    const validSize = moduleSize * totalModules;

    const canvas = document.createElement('canvas');
    canvas.width = validSize;
    canvas.height = validSize;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Could not get 2D context');

    // Fill white background (this creates the border)
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, validSize, validSize);

    // Draw QR modules with offset for border
    ctx.fillStyle = '#000000';
    ctx.translate(border * moduleSize, border * moduleSize); // Offset by border size
    qr.renderTo2dContext(ctx, moduleSize);

    const blob = canvas.toDataURL('image/png');
    return blob;
  }, [size, value]);

  return (
    <img
      id="qr_"
      alt={alt}
      src={QR}
      style={size ? {} : { width: '100%', height: '100%' }}
      className={className}
    />
  );
};
